import { Button, Input, Space, Form, InputNumber, Select, Modal } from 'antd'
import { LeftCircleOutlined } from "@ant-design/icons"
import { PACKAGE_MANAGEMENT, PARTNERS } from '../../assets/constants/route_path'
import { formatCurrency } from '../../utils/string-utils'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { apiGetListPackageDataSponsor, apiGetListPackageDataSponsorPartner, apiGetPackageDataSponsorPartner, apiUpdatePackageDataSponsorPartner } from '../../api'
import { toastError, toastSuccess } from '../../utils/toast'
import { useLoading } from '../../context/LoadingContext'
import { TDM_SOURCE } from '../../assets/constants/default_option'

const initCalcPrice = {
    priceUnit: 0,
    price: 0,
    discount: 0,
}

export default function EditPartnerSponsorPromotion() {
    const [modalUpdate, setModalUpdate] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })
    const [calcPrice, setCalcPrice] = useState(initCalcPrice)
    const [packages, setPackages] = useState<any>([])
    const [otpConfirm, setOtpConfirm] = useState<string>('')
    const [promotionOptions, setPromotionOptions] = useState<any>([])
    const [sponsorOptions, setSponsorOptions] = useState<any>([])
    const { setIsLoading } = useLoading()
    const navigate = useNavigate()
    const [formUpdate] = Form.useForm()
    const [searchParams] = useSearchParams()
    const cpCode = searchParams.get('cpCode')
    const dataPack = searchParams.get('dataPack') + window.location.hash
    const navigateBack = PARTNERS + PACKAGE_MANAGEMENT + `?cpCode=${cpCode}&previousTab=dataSponsor`

    const fetchDataSponsorOptions = useCallback(async () => {
        try {
            setIsLoading(true)
            const resSponsor = await apiGetListPackageDataSponsor({size: 300, page: 1})
            if (resSponsor.data != null) {
                const listPacks = resSponsor.data.packages.map((item: any) => item.package)
                  .filter((item: any) => item.source === TDM_SOURCE)
                setPackages(listPacks)
                const listOptions = listPacks.map((pack: any) => ({ label: `${pack.name} - ${formatCurrency(pack.priceUnit)}`, value: pack.ID }))
                setPromotionOptions(listOptions)
            } else {
                setPromotionOptions({})
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [])

    const fetchDataSponsorPartnerOptions = useCallback(async () => {
        try {
            setIsLoading(true)
            const resSponsor = await apiGetListPackageDataSponsorPartner({ cpCode })
            if (resSponsor.data != null) {
                const listPacks = resSponsor.data.packages.filter((item: any) => item.parentId === 0)
                const listOptions = listPacks.map((pack: any) => ({ label: `${pack.name} - ${formatCurrency(pack.priceUnit)}`, value: pack.ID }))
                setSponsorOptions(listOptions)
            } else {
                setSponsorOptions({})
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }, [])

    const fetchPackage = useCallback(async () => {
        try {
            setIsLoading(true)
            const resp = await apiGetPackageDataSponsorPartner({ cpCode, dataPack })
            if (resp.data !== null) {
                const detailPack = resp.data.package
                formUpdate.setFieldsValue(detailPack)
                setCalcPrice({
                    priceUnit: detailPack.priceUnit,
                    price: detailPack.price,
                    discount: detailPack.discount,
                })
            }
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }, [])

    const handleChangePackage = (packageId: Number) => {
        packages.map((pack: any) => {
            if (pack.ID === packageId) {
                setCalcPrice({ priceUnit: pack.priceUnit, discount: calcPrice.discount, price: pack.priceUnit * (1 - calcPrice.discount) })
                formUpdate.setFieldValue('priceUnit', pack.priceUnit)
            }
        })
    }

    useEffect(() => {
        if (cpCode && dataPack) {
            fetchPackage()
            fetchDataSponsorOptions()
            fetchDataSponsorPartnerOptions()
        }
    }, [cpCode, dataPack, fetchPackage, fetchDataSponsorOptions, fetchDataSponsorPartnerOptions])

    const handleOpenModal = (values: any) => {
        values.cpCode = cpCode
        setModalUpdate({ data: values, isOpen: true })
    }

    const handleCloseModal = () => {
        setModalUpdate({ data: null, isOpen: false })
        if (otpConfirm) {
            setOtpConfirm('')
        }
    }

    const handleConfirm = async () => {
        if (!otpConfirm) {
            toastError('Vui lòng nhập mã OTP xác nhận!')
            return
        }

        try {
            setIsLoading(true)
            modalUpdate.data.price = calcPrice.price
            modalUpdate.data.discount = calcPrice.discount
            const resp = await apiUpdatePackageDataSponsorPartner({ otpConfirm, package: modalUpdate.data })
            if (resp.status === 200) {
                toastSuccess('Cập nhật gói cước thành công!')
                handleCloseModal()
                navigate(navigateBack)
            } else {
                toastError('Có lỗi xảy ra!')
            }
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 200, marginBottom: 20 }}>
                <Button
                    onClick={() => navigate(navigateBack)}
                    icon={<LeftCircleOutlined />}
                    style={{ background: 'gray', color: 'white' }}
                >
                    Trở lại
                </Button>
            </div>
            <h2>Đối tác: {cpCode}</h2>
            <Form
                style={{ maxWidth: 900, width: '90%' }}
                form={formUpdate}
                onFinish={handleOpenModal}
                autoComplete='off'
                labelCol={{ span: 4 }}
                labelAlign="left"
            >
                <Form.Item name='ID' style={{ display: 'none' }} />
                <Form.Item
                    label='Gói cước gốc'
                    name='packageId'
                    rules={[{ required: true, message: 'Vui lòng chọn gói cước' }]}
                >
                    <Select
                        onChange={handleChangePackage}
                        placeholder='Chọn gói cước'
                        options={promotionOptions}
                    />
                </Form.Item>
                <Form.Item
                    label='Tên gói cước'
                    name='name'
                    rules={[{ required: true, message: 'Vui lòng nhập tên gói cước' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='Tên mã gói'
                    name='dataPack'
                    rules={[{ required: true, message: 'Vui lòng nhập mã gói cước' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label='Đơn giá'
                    name='priceUnit'
                    rules={[{ required: true, message: 'Vui lòng nhập đơn giá' }]}
                >
                    <InputNumber
                        onChange={value => setCalcPrice({
                            priceUnit: Number(value),
                            price: Number(value) * (1 - Number(calcPrice.discount)),
                            discount: Number(calcPrice.discount),
                        })}
                        formatter={value => formatCurrency(Number(value))}
                        style={{ width: '100%' }}
                    />
                </Form.Item>
                <div style={{ display: 'flex', gap: 40, flexWrap: 'wrap' }}>
                    <Form.Item label='Giá bán' labelCol={{ span: 8 }} style={{ flex: 1 }}>
                        <InputNumber
                            style={{ width: '100%', marginLeft: 8 }}
                            formatter={value => formatCurrency(Number(value))}
                            value={calcPrice.price}
                            onChange={value => setCalcPrice({
                                ...calcPrice,
                                price: Number(value),
                                discount: Number((1 - Number(value) / calcPrice.priceUnit).toFixed(2))
                            })}
                        />
                    </Form.Item>
                    <Form.Item label='Chiết khấu' labelCol={{ span: 8 }} style={{ flex: 1 }}>
                        <InputNumber
                            style={{ width: '100%' }}
                            value={calcPrice.discount}
                            onChange={value => setCalcPrice({
                                ...calcPrice,
                                discount: Number(value),
                                price: calcPrice.priceUnit * (1 - Number(value))
                            })}
                        />
                    </Form.Item>
                </div>
                <Form.Item
                    label='Mô tả'
                    name='description'
                >
                    <Input.TextArea />
                </Form.Item>
                <Form.Item
                    label='Gói cước áp dụng'
                    name='parentId'
                    rules={[{ required: true, message: 'Vui lòng chọn gói cước' }]}
                >
                    <Select
                        disabled
                        placeholder='Chọn gói cước'
                        options={sponsorOptions}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Space>
                        <Button htmlType="submit" type="primary">Cập nhật</Button>
                        <Button htmlType="reset" type="dashed" danger>Clear</Button>
                    </Space>
                </div>
            </Form>
            <Modal title='Cập nhật gói cước' open={modalUpdate.isOpen}
                onCancel={handleCloseModal}
                footer={[
                    <Button onClick={handleConfirm} type='primary'>
                        Xác nhận
                    </Button>,
                ]}>
                <p><span style={{ color: 'red' }}>*</span> Mã OTP xác nhận</p>
                <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            </Modal>
        </div>
    )
}
